import moment from 'moment';

const mock = [
  {
    field: 'updated_at',
    valueGetter: ({ value }) => value && moment(value).format('DD/MM/YYYY'),
  },
];

export default mock;
